//Must use Nopde 18.15.0 at this time. Code is not running well with Node 20.
const environment: 'audrey' | 'shark' = 'audrey';

export { environment };
